import { useSearch } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { AcceptTermsPage } from './AcceptTermsPage';

export function AcceptTermsRoute(): ReactElement {
    const { redirect } = useSearch({ from: '/split-hero-layout/accept-terms' });
    return <AcceptTermsPage redirect={redirect} />;
}
